import { Theme } from '@mui/material/styles';

export const backgroundImageStyles = (theme: Theme) => ({
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `linear-gradient(135deg, 
      ${theme.palette.primary.main}30,
      ${theme.palette.primary.light}20,
      ${theme.palette.secondary.light}20
    )`,
    zIndex: 0,
    pointerEvents: 'none',
  },
  backgroundImage: 'url("/images/slide-master-bg.jpg")',
  backgroundRepeat: 'no-repeat',
  backgroundColor: theme.palette.grey[50],
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  minHeight: '100vh',
  width: '100vw',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    backgroundImage: 'url("/images/slide-master-bg.jpg")',
    '&::before': {
      background: `linear-gradient(135deg, 
        ${theme.palette.primary.main}20,
        ${theme.palette.primary.light}15,
        ${theme.palette.secondary.light}15
      )`,
    },
  },
});